import { type ModalOpenState } from "./types";

export const DEFAULT_MODAL_OPEN_STATE: ModalOpenState = {
  isCloseable: true,
};
